module.exports = __webpack_public_path__ + "img/572.a329b427.png";